<template>
    <div>
        <rooster-header title="Clients"></rooster-header>

        <ul class="client-list mb-3" v-if="clients.length">
            <li v-for="c in clients">
                <span>{{ c.name }}</span>
                <span>
                    <a href="#" @click.prevent="editRow(c)" class="text-info"><i class="fas fa-edit"></i></a>
                    <a href="#" @click.prevent="deleteRow(c)" class="text-danger"><i class="fas fa-trash"></i></a>
                </span>
            </li>
        </ul>

        <div>
            <h3>Add a new client</h3>
            <client-form @created="onCreated">
                <p v-if="clients.length==0" class="alert alert-info">No clients yet. Here, you can create one easily:</p>
            </client-form>
        </div>

        <b-modal ref="editModal" title="Edit Client"
                 @ok.prevent="sendSubmitSignalToEditForm"
        >
            <client-form @updated="onUpdated" :client="editedRow" ref="editForm"></client-form>
        </b-modal>
    </div>
</template>

<script>
import form from '../ClientForm';
Vue.component('client-form', form);

export default {
    name: "Clients",
    props: [
        //"clients"
    ],

    data() {
        return {
            clients: [],
            editedRow: null,
        }
    },

    mounted() {
        this.fetchRows();
    },

    methods: {
        fetchRows() {
            const that = this;

            window.axios("api/client", {user_id: 'current'})
                .then(function(resp){
                    that.clients = resp.data;
                }).catch(function (error) {
                    if (error.response && error.response.status == 401) {
                        that.$emit("forgot-user");
                    } else {
                        console.log("Got some unexpected error: ", error);
                    }
                });
        },

        onCreated(e) {
            this.fetchRows();
        },

        onUpdated(row) {
            this.editedRow = null;
            this.$refs.editModal.hide();
            this.fetchRows();
        },

        deleteRow(p) {
            const that = this;
            if (!confirm("Are you sure you want to delete this client?")) {
                return ;
            }

            window.axios.delete("api/client/" + p.id)
                .then(function(resp){
                    that.fetchRows();
                })
        },

        editRow(row) {
            this.$refs.editModal.show();
            this.editedRow = row;
        },

        sendSubmitSignalToEditForm() {
            this.$refs.editForm.sendSubmitSignal()
        }
    }

}
</script>

<style scoped>
.client-list {
    list-style: none;
    margin: 0;
    padding: 0;
}
.client-list li {
    display: flex;
    justify-content: space-between;
    padding: 0.75rem;
}
.client-list li:nth-of-type(2n+1) {
    background-color: rgba(0, 0, 0, 0.05);
}
</style>
